export class UserTypeTokens {
  egacStaff = 'LY8ppWRSWvAmbKiSo70YiTNePiiOFF';
  cabUser = 'LY8ppWRSWvAmbKkgl70YiTNeBiiOFD';
  externalStaff = 'LY8ppWRSWvAlolfgl70YiTNeBiiOFK';
  trainee = 'LY8ppWRSWvldkKkgl70YiTNeBiiOFJ';
  cabRepresentative = 'LY8ppWRSWvAmbKkgl70UIYOUYUIOIUO';
  superAdmin = "IY8ppWRSWvAmbK56o70YiTNePiiOyF"
}
